module.exports = __webpack_public_path__ + "static/media/footer-accueil-active.ffd780b1.png";